<template>
  <FullCalendar />
</template>

<script>
import FullCalendar from "./components/FullCalendar.vue";

export default {
  name: "App",
  components: {
    FullCalendar,
  },
};
</script>
